//A HeroBanner komponens a főablak tartalmát és elrednését kezeli, tartalmaz egy képet és mellette egy szöveges tartalmat.

import React from 'react';
import { Box, Stack, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import HeroBannerImage from '../assets/images/banner.png';


const HeroBanner: React.FC = () => {
  // Navigációhoz használt hook, ami a useNavigate() függvényt adja vissza
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        mt: { lg: '212px', xs: '70px' },
        ml: { sm: '50px' },
        position: 'relative',
        pb: '100px',
        '@media (max-width:1400px)': {
          mt: '50px', // kisebb oldalak esetén
        },
      }}
      p="20px"
    >
      {/* A HeroBanner címe */}
      <Typography color="#231c87" fontWeight="600" fontSize="26px">
        Fitness Club
      </Typography>
      {/* A HeroBanner szövege */}
      <Typography
        fontWeight={700}
        sx={{
          fontSize: { lg: '45px', xs: '40px' },
          '@media (max-width:1400px)': {
            fontSize: '36px', // kisebb oldalak esetén
          },
        }}
      >
        Get fit with our exercises
      </Typography>
      <Typography fontSize={20} lineHeight="35px" mb={2}>
        Checkout the most effective exercises
      </Typography>
      {/* A HeroBanner gombja, ami átnavigál az Exercises oldalra */}
      <Button
        onClick={() => navigate('/exercises')}
        variant="outlined"
        sx={{
          color: 'black',
          '&:hover': {
            backgroundColor: '#231c87',
            color: 'white',
          },
        }}
      >
        Checkout
      </Button>
      {/* A HeroBanner képe, Arnold Schwarzenegger */}
      <img
        src={HeroBannerImage}
        alt="Hero Banner"
        className="hero-banner-img"
        style={{ marginBottom: '50px' }}
      />
    </Box>

  );
};

export default HeroBanner;